import type { StyleRenderer, RenderParams, RendererContext } from '../../types';
import { registerRenderer } from './base';
import { drawUchiwaBackground, drawUchiwaBorder, cornerRadiusPx } from '../uchiwa-shape';
import { layoutText, drawChars, strokeChars } from '../text';
import { UCHIWA_SIZES } from '../../types';

const boldRenderer: StyleRenderer = {
  name: 'bold',
  label: 'ボールド',
  description: 'Bold heavy text with outline',

  render(ctx: CanvasRenderingContext2D, params: RenderParams, _rc: RendererContext): void {
    const { text, textColor, backgroundColor, secondaryColor, canvasWidth, canvasHeight, textOrientation } = params;

    const cr = cornerRadiusPx(
      UCHIWA_SIZES.jumbo.cornerRadius,
      UCHIWA_SIZES.jumbo.printableArea.width,
      canvasWidth,
    );

    drawUchiwaBackground(ctx, { canvasWidth, canvasHeight, cornerRadius: cr, backgroundColor });

    const pad = canvasWidth * 0.08;
    const areaW = canvasWidth - pad * 2;
    const areaH = canvasHeight - pad * 2;
    const cx = canvasWidth / 2;
    const cy = canvasHeight / 2;

    const positions = layoutText(ctx, {
      text,
      orientation: textOrientation,
      fontFamily: 'Noto Sans JP',
      fontWeight: '900',
      areaWidth: areaW,
      areaHeight: areaH,
      centerX: cx,
      centerY: cy,
    });

    // Outline first (behind fill)
    const outlineWidth = positions[0] ? positions[0].fontSize * 0.08 : 8;
    strokeChars(ctx, positions, 'Noto Sans JP', '900', secondaryColor, outlineWidth);

    // Fill
    drawChars(ctx, positions, 'Noto Sans JP', '900', textColor);

    drawUchiwaBorder(ctx, { canvasWidth, canvasHeight, cornerRadius: cr, backgroundColor });
  },

  renderThumbnail(ctx: CanvasRenderingContext2D, size: number): void {
    ctx.fillStyle = '#FFF5F8';
    ctx.fillRect(0, 0, size, size);
    ctx.font = `900 ${size * 0.45}px sans-serif`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.strokeStyle = '#FFB5D1';
    ctx.lineWidth = size * 0.04;
    ctx.lineJoin = 'round';
    ctx.strokeText('A', size / 2, size / 2);
    ctx.fillStyle = '#FF3D7F';
    ctx.fillText('A', size / 2, size / 2);
  },
};

registerRenderer(boldRenderer);
export default boldRenderer;
